import ServiceMerchant from '../../services/Merchant';

export const LOADING_MERCHANT = 'LOADING_MERCHANT';
function loadingMerchant() {
  return {
    type: LOADING_MERCHANT,
  };
}

export const SET_MERCHANT = 'SET_MERCHANT';
function setMerchant(merchant) {
  return {
    type: SET_MERCHANT,
    payload: merchant,
  };
}

export const FINISH_SET_MERCHANT = 'FINISH_SET_MERCHANT';
export function finishSetMerchant() {
  return {
    type: FINISH_SET_MERCHANT,
  };
}

export const getServices = () => {
  return async dispatch => {
    dispatch(loadingMerchant());
    try {
      const response = await new ServiceMerchant().getServices();
      dispatch(setMerchant(response.data));
    } catch (error) {
      console.error('error', error);
    }
  };
};



// WEBPACK FOOTER //
// ./src/store/merchant/actions.js